module.exports = __webpack_public_path__ + "static/img/glbig03.5e353978.jpg";